import React, { createContext, useContext, useState } from "react";
const defaultValue = {
  libraryId: null,
  setLibraryId: () => {},
  keyword: "",
  setKeyword: () => {},
};
// Create a context for the library state
const GazetteContext = createContext(defaultValue);

// Provider component to wrap around your application
export const GazetteProvider = ({ children }) => {
  const [libraryId, setLibraryId] = useState(null); // Default libraryId is null
  const [keyword, setKeyword] = useState("keyword");
  return (
    <GazetteContext.Provider
      value={{ libraryId, setLibraryId, keyword, setKeyword }}
    >
      {children}
    </GazetteContext.Provider>
  );
};

// Custom hook to use the context
export const useGazette = () => useContext(GazetteContext);
